<script>
	import { Alert } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import { format } from 'svelte-i18n';

	export let device;

	const navigateToSetting = (setting, subSetting) => {
		routeToDeviceSettings.setTarget(device.id, setting, subSetting);
	};
</script>

<Alert
	type="warning"
	heading={$format('alert_heading_update_required', {
		default: 'Firmware update required',
	})}
	message={$format('alert_message_update_required_statistics', {
		default: 'To show device statistics please update your device',
	})}
	class="mb-s"
	cta={{
		title: capFirstChar(
			$format('button_update', {
				default: 'update',
			}),
		),
	}}
	on:cta_click={() => navigateToSetting('settings', 'firmware_version')}
/>
